import { useQuery, useQueryClient } from "@tanstack/react-query";

const dtrDataKey = 'dtrData';

const fetchDtrData = async () => {
    return {
        payperiod: 0
    };
}

export const useDtrData = () => {
    const queryClient = useQueryClient();

    const { data: dtrData = [] } = useQuery({
        queryKey: [dtrDataKey],
        queryFn: fetchDtrData,
        staleTime: Infinity
    });

    const setDtrData = (key, value) => {
        queryClient.setQueryData([dtrDataKey], (oldData) => ({
            ...oldData,
            [key]: value,
        }));
    }

    return {
        dtrData,
        setDtrData,
    }
}